<template>
  <div class="logs-wrap" :class="{ modal: Boolean(logUrl) }">
    <virtualList
      class="log"
      ref="log"
      @scroll="handleWheel"
      :style="{ [terminalHeight ? 'height' : '']: terminalHeight }"
      :data-key="'id'"
      :data-sources="logs"
      :data-component="logLineCom"
      :estimate-size="22"
      :keeps="100"
    />

    <div class="loading">
      <a-button @click="handleToBottom"> <a-icon type="arrow-down" />回到底部 </a-button>
      <a-button style="margin: 0 10px" @click="handleToTop"> <a-icon type="arrow-up" />回到顶部 </a-button>
      <a-button @click="handleDownLoad"><a-icon type="download" />下载日志 </a-button>
      <a-button style="margin: 0 10px" @click="handleClear"><a-icon type="desktop" />清除屏幕 </a-button>
    </div>
  </div>
</template>

<script>
// TODO 虚拟滚动
import { downloadLogApi } from '../../../api/Dispatch/TaskManage'

const urlReg = /(http|ftp|https|www):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/

import LogLine from './LogLine'
import virtualList from 'vue-virtual-scroll-list'
export default {
  components: { virtualList },
  data() {
    return {
      logs: [],
      autoScroll: true,
      ws: {},
      logPath: '',
      logLineCom: LogLine
    }
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close()
    }
  },
  methods: {
    init(logPath) {
      //process.env.baseURL
      // let logPath = 'http://starsee-open-bucuket.oss-cn-hangzhou.aliyuncs.com/worker/logs/spider_81_mil/task_spider_81_mil_2021-04-27T07:30:10.004Z_00.log'
      // 实例化socket，这里的实例化直接赋值给this.ws是为了后面可以在其它的函数中也能调用websocket方法，例如：this.ws.close(); 完成通信后关闭WebSocket连接
      // TODO nginx代理
      this.ws = new WebSocket(process.env.VUE_APP_WS_URL + '/ws/spider/schedule/record/log?logPath=' + logPath)

      //监听是否连接成功
      this.ws.onopen = () => {
        //连接成功则发送一个数�?
        this.ws.send('连接成功')
      }

      //接听服务器发回的信息并处理展
      this.ws.onmessage = (data) => {
        let result = data.data.replace(
          /^[� | \u0001 | \u0002 | \u0003 | \u0004 | \u0005 | \u0006 | \u0007 |\u0015 | \u0016 | \u0017 | \u0018 | \u000f | \u001a | \u001e | \u0019 | \u001f | \u001b | \u001c | \t]/g,
          ''
        )
        result = result.replace(/error/g, "<span class='terminal-high-light-red'>error</span>")
        result = result.replace(/ERROR/g, "<span class='terminal-high-light-red'>ERROR</span>")
        result = result.replace(/Error/g, "<span class='terminal-high-light-red'>Error</span>")

        result = result.replace(/\[/g, "<span class='terminal-high-light-lime'>[</span>")
        result = result.replace(/\]/g, "<span class='terminal-high-light-lime'>]</span>")

        // 假定一行内只有一个网址
        const urlExec = urlReg.exec(result)
        if (urlExec && urlExec[0]) {
          result = result.replace(
            urlExec[0],
            `<a href='${urlExec[0]}' target='_blank' class='terminal-high-light-a'>${urlExec[0]}</a>`
          )
        }

        result.trim()
        this.logs.push({ result, id: Math.random() })

        if (this.logs.length > 1000) {
          this.logs.shift()
        }

        this.$nextTick(() => {
          let $log = this.$refs.log?.$el
          if (!$log) return
          if (this.autoScroll) {
            $log.scrollTop = $log.scrollHeight
          }
        })
      }

      //监听连接关闭事件
      this.ws.onclose = () => {
        //监听整个过程中websocket的状�?
        console.log('ws连接状态：' + this.ws.readyState)
      }

      //监听并处理error事件
      this.ws.onerror = function (error) {
        console.error(error)
      }
    },

    handleWheel() {
      this.autoScroll = false
      let $log = this.$refs.log ? this.$refs.log.$el : {}

      // 给一点点宽容度
      if ($log.scrollTop + $log.clientHeight + 22 >= $log.scrollHeight) {
        this.autoScroll = true
      }
    },

    handleToBottom() {
      let $log = this.$refs.log?.$el
      if (!$log) return
      $log.scrollTop = $log.scrollHeight
      this.autoScroll = true
    },

    handleToTop() {
      let $log = this.$refs.log?.$el
      if (!$log) return
      $log.scrollTop = 0
      this.autoScroll = false
    },

    handleDownLoad() {
      let { taskId: taskIdFromQuery } = this.$route.query
      let taskId = this.taskId || taskIdFromQuery
      if (!taskId) return
      downloadLogApi({ taskId }).then((res) => {
        if (res.code === 200) {
          const logPath = res.extra.logPath
          let downloadElement = document.createElement('a')
          let fileName = '调度日志.txt'
          downloadElement.href = logPath
          downloadElement.target = '_blank'
          downloadElement.download = fileName
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
        }
      })
    },

    handleClear() {
      this.logs = []
    },

    forceWheel() {
      let $log = this.$refs.log?.$el
      if (!$log) return
      if ($log.scrollTop === $log.scrollHeight) {
        $log.scrollTop -= 1
      } else {
        $log.scrollTop += 1
      }
    }
  },

  props: {
    logUrl: {
      type: String
    },
    terminalHeight: {
      type: String
    },
    taskId: {
      type: String
    }
  },

  created() {
    let { logUrl: logUrlFromQuery } = this.$route.query
    let logUrl = this.logUrl || logUrlFromQuery
    if (logUrl) {
      this.logPath = logUrl
      this.init(this.logPath)
    }
  }
}
</script>

<style lang="less" scoped>
.logs-wrap {
  height: 100%;
  padding-bottom: 16px;

  &.modal {
    padding-bottom: 0px;
  }
}
.loading {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.log {
  height: calc(100vh - 280px);
  background: #454545;
  width: 100%;
  padding: 0 10px;
  overflow: auto;
  color: #fff;
  overscroll-behavior: contain;
}
</style>
